import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { GET_BOOST_PAST_DUE_AMOUNT } from "components/Pages/Boost/mutations";
import BannerCritical from "components/common/Banners/BannerCritical";
import { Button, MobileContext, PromoContext } from "components/common";
import { BoostCountDownBanner } from "@tomocredit/common-fe/components";
import { boostLookbackSelectionUrl } from "../consts";

export const BoostBanner = () => {
  const { isMobile } = useContext(MobileContext);
  const { promoInfo } = useContext(PromoContext);

  const { data } = useQuery(GET_BOOST_PAST_DUE_AMOUNT);
  const pastDueAmount = data?.getUserProductStatus?.pastDueAmount;
  const isPastDue = pastDueAmount > 0;

  const history = useHistory();
  const { pathname } = history.location;
  const showCriticalBanner = ["/boost"].includes(pathname);
  const showPromoBanner = ["/boost", "/boost/upgrade-membership"].includes(pathname);

  if (showCriticalBanner && isPastDue) {
    return (
      <BannerCritical
        title="Your last payment has failed. Update your payment method and/or make a payment so we can continue reporting positive credit history."
        type="critical"
        hasModal={false}
        ButtonComponent={
          (<Button
            className="font-normal mt-3 md:mt-0"
            onClick={() => history.push(`/settings?section=payment-method`)}
            paddingHorizontal={`${isMobile ? 26 : 16}px`}
            paddingVertical={`${isMobile ? 6 : 8}px`}
          >
            Resolve Now
          </Button>)
        }
        containerClassName={isMobile ? "" : "mt-2"}
      />
    );
  }

  if (showPromoBanner && promoInfo.showCountDown){
    return (
      <BoostCountDownBanner
        text={promoInfo.text}
        deadline={promoInfo.deadline}
        onClick={() => {
          history.push(boostLookbackSelectionUrl);
        }}
        type="upgrade"
        belowMd={isMobile}
      />
    );
  }
  return null;
};